@if (data?.content?.tiles?.length) {
  <div class="container max-width">
    @for (item of data.content.tiles; track item) {
      <customer-app-equity-tile-item [tile]="item"></customer-app-equity-tile-item>
    }
  </div>
}
